import type { ActivityRestoreButtonProps } from "./activity-restore-button.type";

import { useTranslation } from "react-i18next";

import RestoreButton from "@/components/Header/Button/RestoreButton";
import { getActivityRestoreInvalidateKeys } from "@/modules/activity/activity-restore";
import { useModelRestore } from "@/modules/model-restore";

export const ActivityRestoreButton = ({
  isBatch,
  activity,
  restoreModel,
  restoreId,
}: ActivityRestoreButtonProps) => {
  const { t } = useTranslation();

  const invalidateKeys = getActivityRestoreInvalidateKeys(activity);

  const { mutate: restore, isPending: isRestoring } = useModelRestore({
    model: restoreModel,
    id: restoreId,
    invalidateKeys,
  });

  return (
    <RestoreButton
      label={isBatch ? t("global:batchRestore.label") : t("global:restore")}
      loading={isRestoring}
      onClick={restore}
    />
  );
};
